/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignChannelDestroyPathParams, CampaignChannelDestroyResponse } from '../types/CampaignChannelDestroy'

/**
 * DELETE /campaigns/:campaign/channels/:channel
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignChannelController.php CampaignChannelController::destroy
 */
export async function campaignChannelDestroy(
	campaign: CampaignChannelDestroyPathParams['campaign'],
	channel: CampaignChannelDestroyPathParams['channel'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignChannelDestroyResponse>> {
	return axiosInstance.delete(`/campaigns/${campaign}/channels/${channel}`, config)
}
